import { WorkspaceType } from '@/api/user-api'

const isQuotaBasedWorkspaceType = (workspaceType: WorkspaceType): boolean => {
  const databasePlan: WorkspaceType[] = [
    WorkspaceType.Vip,
    WorkspaceType.VipTrial,
    WorkspaceType.PaymentVip,
    WorkspaceType.Enterprise,
    WorkspaceType.Internal,
  ]
  return !databasePlan.includes(workspaceType)
}

export default isQuotaBasedWorkspaceType
